/**
 * Legacy subscription read-only mode constants
 */

export const LEGACY_SUBSCRIPTION_MESSAGE =
  "This is a legacy subscription and is no longer available here. Please continue on our new platform: DataSift";

export const REISIFT_URL = "https://app.reisift.io/";

/**
 * Get the message for disabled actions
 */
export const getLegacySubscriptionMessage = (): string => {
  return LEGACY_SUBSCRIPTION_MESSAGE;
};
